import { Typography, FormControlLabel } from '@mui/material';
import { FunctionComponent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import Checkbox from '@Components/Checkbox';
import { ReactHookFormError } from '@Typings/global.types';

import CheckboxWrapperProps from './CheckboxWrapper.types';

const CheckboxWrapper: FunctionComponent<CheckboxWrapperProps> = (
  props: CheckboxWrapperProps
): JSX.Element => {
  const { name, label, onChange, initialValue, ...resProps } = props;
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={initialValue}
      render={({ field }) => (
        <>
          <FormControlLabel
            sx={{
              m: '0',
              '& .MuiCheckbox-root': {
                mr: 1,
              },
              alignItems: 'start',
            }}
            control={
              <Checkbox
                {...resProps}
                {...field}
                ref={null}
                onChange={(
                  e: React.ChangeEvent<HTMLInputElement>,
                  checked: boolean
                ) => {
                  if (onChange) {
                    onChange(e, checked);
                  }
                  field.onChange(e);
                }}
              />
            }
            label={label}
          />
          {errors[name] && (
            <Typography color="error" variant="helpText">
              {(errors[name] as ReactHookFormError)?.message}
            </Typography>
          )}
        </>
      )}
    />
  );
};

CheckboxWrapper.defaultProps = {
  initialValue: false,
};

export default CheckboxWrapper;
